import React from 'react';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  children?: React.ReactNode;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ children, className = '', ...props }, ref) => {
    return (
      <label className={`flex items-start gap-2.5 cursor-pointer group ${className}`}>
        <div className={`relative flex items-center justify-center mt-0.5 shrink-0`}>
          <input
            type="checkbox"
            ref={ref}
            className="peer appearance-none w-4 h-4 rounded-[4px] border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 checked:bg-emerald-600 dark:checked:bg-emerald-500 checked:border-emerald-600 dark:checked:border-emerald-500 ring-offset-white focus:outline-none focus:ring-2 focus:ring-emerald-500/30 transition-all cursor-pointer"
            {...props}
          />
          <svg
            className="absolute w-2.5 h-2.5 text-white pointer-events-none opacity-0 peer-checked:opacity-100 transition-opacity"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="3.5"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        {children && (
          <div className="flex flex-col flex-1 select-none">
            {children}
          </div>
        )}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';
